export const site = {
  name: '爆料看点',
  enName: 'BAOLIAO KANDIAN',
  slogan: '把爆料拆开讲',
  tagline: '不只告诉你发生了什么，还把爆料背后细节、被忽略的伏笔、时间线关键节点和事件隐藏关联摊开来。',
  description:
    '爆料看点是一个专注事件拆解的内容站，围绕爆料背后细节、被忽略的伏笔、时间线关键节点与事件隐藏关联四个维度，把零散线索整理成一条可以顺着看的脉络。',
  email: 'contact@baoliaokandian.site',
  workingHours: '工作日 10:00 - 19:00',
  since: '2024',
};

export interface NavItem {
  label: string;
  to: string;
}

export const navItems: NavItem[] = [
  { label: '首页', to: '/' },
  { label: '拆解档案', to: '/dossiers' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export const homeAnchors = [
  { label: '拆解维度', href: '#dimensions' },
  { label: '热门拆解', href: '#hot' },
  { label: '时间线长廊', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
];

export const stats = [
  { value: '860+', label: '拆解档案', desc: '覆盖四类核心维度' },
  { value: '12,400', label: '时间线节点', desc: '全部可回溯核对' },
  { value: '96%', label: '线索可复现', desc: '同一素材可交叉验证' },
  { value: '48h', label: '平均出稿', desc: '热度之后仍继续跟进' },
];

export const testimonials = [
  {
    name: '许屿',
    role: '长期读者',
    text: '以前刷完一圈只记住情绪，这里看完能记住顺序。时间线那一块是真的有用，帮我省掉了自己拼线索的时间。',
  },
  {
    name: '陈默',
    role: '内容从业者',
    text: '把「多余的元素」单独拿出来讨论这件事，思路很干净。不煽情，只对素材。',
  },
  {
    name: '罗静之',
    role: '在职编辑',
    text: '最喜欢伏笔清单，条数不多但每条都落到具体时间点，读起来不累。',
  },
  {
    name: '周听',
    role: '普通读者',
    text: '原本只是随手点开，结果顺着关联图谱一路看到凌晨。排版也舒服，不会一直弹东西。',
  },
];

export const faqs = [
  {
    q: '「爆料看点」主要拆解什么内容？',
    a: '我们围绕四个维度展开：爆料背后细节、被忽略的伏笔、时间线关键节点、事件隐藏关联。每个拆解都会把原始素材、出现时间点和对应关系列清楚，方便你自己复核。',
  },
  {
    q: '拆解内容会给出明确结论吗？',
    a: '会给出可验证的节奏判断，但不会替你下动机结论。凡是只能推测的部分，我们会标注为「待确认」，和已确认的内容分开呈现。',
  },
  {
    q: '为什么有些拆解看起来很啰嗦，连几帧的画面都要记？',
    a: '因为伏笔的识别标准就是「当时看起来多余」。只有把多余的细节先记下来，后面才可能对上。这正是被忽略的伏笔最核心的部分。',
  },
  {
    q: '档案会持续更新吗？',
    a: '会。事件有新进展时，我们会直接更新对应档案的时间线，旧节点保留不删，方便你看到走势是怎么变的。',
  },
  {
    q: '我可以投稿或提供线索吗？',
    a: '可以。通过「联系我们」页面提交即可，请尽量附上原始素材的时间与来源，方便我们做交叉验证。',
  },
];